import * as React from 'react';

import { PaywallScreens } from '~analytics/types';
import { LongRoomsPaywall } from '~teacher/components/rooms/RoomsPaywall/LongRoomsPaywall';
import {
  useRoomsPaywallDispatch,
  useRoomsPaywallState,
} from '~teacher/components/rooms/RoomsPaywall/RoomsPaywallProvider';
import {
  MaxRoomsPaywall,
  MaxStudentsInRosterPaywall,
} from '~teacher/components/rooms/RoomsPaywall/ShortRoomsPaywall';

export function RoomsPaywall() {
  const { paywallTouch, isOpen } = useRoomsPaywallState();
  const dispatch = useRoomsPaywallDispatch();
  const onClose = () => dispatch({ type: 'close' });

  if (!paywallTouch) return null;

  const [primaryPaywall] = paywallTouch;

  switch (primaryPaywall) {
    case PaywallScreens.RoomsAddRoom:
    case PaywallScreens.RoomsShareRoom:
    case PaywallScreens.RoomsAddRoster:
    case PaywallScreens.AppHeaderAddRoster:
    case PaywallScreens.AppHeader: {
      return (
        <LongRoomsPaywall
          onClose={onClose}
          paywallTouch={paywallTouch}
          open={isOpen}
        />
      );
    }
    case PaywallScreens.RoomsMaxRooms: {
      return (
        <MaxRoomsPaywall
          onClose={onClose}
          paywallTouch={paywallTouch}
          open={isOpen}
        />
      );
    }
    case PaywallScreens.RoomsRosterMaxStudent: {
      return (
        <MaxStudentsInRosterPaywall
          onClose={onClose}
          paywallTouch={paywallTouch}
          open={isOpen}
        />
      );
    }
    default:
      return null;
  }
}
